export const isQuestionNumberEnabled = (question) =>
  question?.showQuestionIndex === true ||
  question?.showQuestionIndex === "true";

export const getQuestionTitleNumber = (question, fallbackIndex) => {
  if (!isQuestionNumberEnabled(question)) {
    return null;
  }

  const raw = question?.number;

  if (raw !== null && raw !== undefined && String(raw).trim() !== "") {
    const parsed = Number(raw);

    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  if (typeof fallbackIndex === "number" && Number.isFinite(fallbackIndex)) {
    return fallbackIndex;
  }

  return null;
};
